import images from 'assets/images/images'
import Checkbox from 'components/form-elements/checkbox/Checkbox'
import Input from 'components/form-elements/input/Input'
import ReactSelect from 'components/form-elements/select/ReactSelect'
import React, { useEffect, useState } from 'react'
import Button from 'components/form-elements/buttons/Button'
import useToast from 'hooks/useToast'
import { setRegister, setRegisterCode } from 'redux/register/registerSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useRequest } from 'hooks/useRequest'
import CountryFlagSvg from 'country-list-with-dial-code-and-flag/dist/flag-svg'
import CountryList from 'country-list-with-dial-code-and-flag'
import LoaderTwo from 'pages/LoaderTwo'
import TriggerButton from 'components/triggerButton/TriggerButton'
import useTranslate from 'hooks/useTranslate'
import {Trans} from 'react-i18next'
import {dataLayerPush} from 'utils/Datalayer'

// let SecurePassword = ({ value, onChange, mask, label, name }) => {
// 	let updatePass = (e) => {
// 		let newValue = e.target.value
// 		let newLength = newValue.length / mask.length
// 		let oldLength = value.length * mask.length

// 		if (value.length < newLength) onChange(value + newValue.slice(oldLength))

// 		if (value.length > newLength) onChange(value.slice(0, newLength))
// 	}

// 	return (
// 		<div className='w-100'>
// 			<div>{label}</div>
// 			<input autoComplete='off' value={mask.repeat(value?.length)} name={name} onChange={updatePass} className='information-input mb-4' />
// 		</div>
// 	)
// }

const StageRegister = ({ setRegisterState }) => {
	const { showToast } = useToast()
	const dispatch = useDispatch()
	const { register } = useSelector((state) => state)
	const [request, loading] = useRequest()
	const countries = [
		...CountryList.getAll()
			.map((ct) => ({ label: ct.data.dial_code, value: ct.data.dial_code, image: CountryFlagSvg[ct.data.code] }))
			.sort((a, b) => a.value - b.value),
	]

	const skipStage3 = () => {
		setRegisterState((prev) => prev + 1)
	}
	const {t} = useTranslate()

	const [registerForm, setRegisterForm] = useState({
		email: register.registerDataMail,
		firstName: '',
		lastName: '',
		countryCode: '',
		phone: '',
		userAgreement: null,
		newsletterPermission: false,
		remember: '',
	})

	const [password, setPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')

	const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA

	const onRegister = async () => {
		const validate = () => {
			const upper = /[A-Z]/,
				lower = /[a-z]/,
				number = /[0-9]/,
				special = /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
		
			if (password.length >= 8 &&
				upper.test(password) &&
				lower.test(password) &&
				number.test(password) &&
				special.test(password)
			) {
				return true;
			}
		
			return false;
		}
		if (password !== confirmPassword) {
			showToast(t('passwordsNotMatch'), 'error')
		}
		if(registerForm.userAgreement == null){
			showToast(t('fillAllFieldsAgreement'), 'error')
		}else if(!validate()) {
			showToast(t('passwordConfirmToast'),'error')
		} else {
			dispatch(setRegister(registerForm))

			await window.grecaptcha.ready(function () {
				window.grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function (token) {
					request('/InternalAuth/InternalRegister', {
						method: 'POST',
						data: {
							email: registerForm.email,
							password: password,
							confirmPassword: confirmPassword,
							firstName: registerForm.firstName,
							lastName: registerForm.lastName,
							countryCode: registerForm.countryCode.value.slice(1),
							phone: registerForm.phone,
							userAgreement: registerForm.userAgreement,
							newsletterPermission: registerForm.newsletterPermission,
							token: token,
						},
					}).then((res) => {
						if (res?.data) {
							dataLayerPush({
								event:"sign_up",
								user_phone:registerForm.phone,
								user_email :registerForm.email,
							})
							dispatch(setRegisterCode(res.data.result)) //stage code..
							skipStage3()
						}
					})
				})
			})
		}
	}

	useEffect(() => {
		const defaultCountry = countries.find((ct) => ct.value == '+90')
		setRegisterForm({ ...registerForm, countryCode: defaultCountry })
	}, [])

	const handleChange = (e, name) => {
		if (name && name?.name !== 'undefined' && name?.name != 'countryCode') {
			setRegisterForm((prev) => ({ ...prev, [name]: e }))
		} else if (name?.name !== 'undefined' && name?.name == 'countryCode') {
			setRegisterForm((prev) => ({ ...prev, [name?.name]: e.value }))
		} else {
			setRegisterForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
		}
	}
	const handleOnApprove = () => {
		setRegisterForm((prev) => ({ ...prev, userAgreement: true }))
	}
	return (
		<div className='register-container'>
			<LoaderTwo isDataLoading={loading} />
			<div className="inputComponent">
				<h1 className="header-l">{t('register')}</h1>
			</div>
			<div className='register-container-flexInput'>
				<Input
					containerClassName={'w-50'}
					className={''}
					labelClassName={'stageTwoLabel'}
					placeholder={t('labelName')}
					type={'text'}
					required
					textLabel={t('labelName')}
					name='firstName'
					value={registerForm.firstName}
					onChange={handleChange}
				/>
				<Input
					containerClassName={'w-50'}
					className={''}
					labelClassName={'stageTwoLabel'}
					placeholder={t('labelSurame')}
					type={'text'}
					required
					textLabel={t('labelSurame')}
					name='lastName'
					value={registerForm.lastName}
					onChange={handleChange}
				/>
			</div>
			<div className='register-container-flexInput'>
				<ReactSelect
					isSearchable
					labelText={t('labelCountry')}
					value={registerForm.countryCode}
					handleChange={(d) => handleChange({ target: { name: 'countryCode', value: d } })}
					className={'mr-2 mt-01 countrySelect'}
					placeholder={t('labelCountry')}
					options={countries}
				/>

				<Input
					containerClassName={'inputPhoneClassNameContainer'}
					className={''}
					labelClassName={'stageTwoLabel'}
					placeholder={t('labelPhone')}
					type={'number'}
					maxLength={10}
					required
					textLabel={t('labelPhone')}
					name='phone'
					value={registerForm.phone}
					onChange={handleChange}
				/>
			</div>
			<Input
				containerClassName={'inputPhoneClassNameContainer'}
				className={''}
				labelClassName={'stageTwoLabel'}
				placeholder={t('labelPassword')}
				type={'password'}
				textLabel={t('labelPassword')}
				name='password'
				required
				value={password}
				onChange={(e) => setPassword(e.target.value)}
			/>
			<Input
				containerClassName={'inputPhoneClassNameContainer'}
				className={''}
				labelClassName={'stageTwoLabel'}
				placeholder={t('labelConfirmPassword')}
				type={'password'}
				required
				textLabel={t('labelConfirmPassword')}
				name='confirmPassword'
				value={confirmPassword}
				onChange={(e) => setConfirmPassword(e.target.value)}
			/>
			<Checkbox
				textLabel={t('rememberMe')}
				id={"onecheck"}
				className={'checkbox-orange mb-4'}
				value={setRegisterForm.remember}
				checked={setRegisterForm.remember}
				onChange={() => setRegisterForm((prev) => ({ ...prev, remember: !prev.remember }))}
			/>
			<Checkbox
				textLabel={<span><Trans i18nKey='userAgreementContinueText' components={{ triggerBtn: <TriggerButton onApprove={handleOnApprove} text={t('userAgreement')} referance='kullanici-sozlesmesi'  />}} /></span>}
				id={"twocheck"}
				className={'checkbox-orange mb-4'}
				value={registerForm.userAgreement}
                checked={registerForm.userAgreement}
				onChange={() => setRegisterForm((prev) => ({ ...prev, userAgreement: !prev.userAgreement }))}
			/>
			<Checkbox
				className={'checkboxLongTextClassName checkbox-orange mb-4'}
				id={"threecheck"} 
				textLabel={<span><Trans i18nKey='clarificationText' components={{triggerBtn:<TriggerButton onApprove={() => {setRegisterForm((prev) => ({ ...prev, newsletterPermission: true }))}} text={t('here')} referance='aydinlatma-metni'/>}} /></span>}
				checked={registerForm.newsletterPermission}
				onChange={() => setRegisterForm((prev) => ({ ...prev, newsletterPermission: !prev.newsletterPermission }))}
			/>
			<div className='register-container-btnGroup'>
				<Button onClick={() => setRegisterState((prev) => prev - 1)} className={'stageTwoBtnWhite'} icon={images.leftArrow} text={''} />
				<Button onClick={onRegister} className={'stageTwoBtnRed'} icon={''} text={t('registerBtn')} />
			</div>
		</div>
	)
}

export default StageRegister
